import React from 'react';

import A from '../components/a';

const FooterLink = ({ href, text, isExternal, ...rest }) => (
    <li
        css={{
            ':not(:first-child)': { marginLeft: 24 },
            '@media(max-width: 479px)': { display: isExternal ? 'none' : null }, // hack: hide contact link at smallest breakpoint so all links fit for now
        }}
    >
        <A href={href} isExternal={isExternal} {...rest}>{text}</A>
    </li>
);

export default () => (
    <footer css={{
        height: 48,
        color: '#8d8d8f',
        backgroundColor: '#2a2b2c',
        fontWeight: 300,
        fontSize: 15,
        width: '100%',
        '@media(max-width: 767px)': {
            height: 66,
        }
    }}>
        <div css={{
            maxWidth: 1024,
            padding: '12px 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            margin: '0 auto',
            '@media(max-width: 767px)': {
                flexDirection: 'column',
            }
        }}>
            <span>&copy; 2018 Walletwyse, LLC</span>
            <ul css={{
                listStyle: 'none',
                marginBottom: 0,
                display: 'flex',
                padding: 0,
            }}>
                <FooterLink href="/about" text="About Us" />
                <FooterLink href="mailto:info@walletwyse.com" target="_blank" text="Contact Us" isExternal />
                <FooterLink href="/terms-and-conditions" text="Terms and Conditions" />
                <FooterLink href="/site-map" text="Site Map" />
            </ul>
        </div>
    </footer>
);
